export { isCharterDepartureOutOfSystemRange } from 'lib/flights/charterBookingWindow'

/**
 * Decides which feeder-flight copy to show below the charter tile.
 *
 * A configured airport shows "connecting flights included" only when either:
 * - journey data has not loaded yet (we don't know prices), or
 * - at least one journey has a non-zero feederEstimatedPrice.
 *
 * When flights are loaded and both prices are zero the feeder is not available
 * for those dates, so fall back to the non-configured "add at checkout" copy.
 */
export function resolveShowConfiguredFeederCopy({
  isConfiguredFeederAirport,
  hasFlights,
  departingFeederEstimatedPrice,
  returningFeederEstimatedPrice,
}: {
  isConfiguredFeederAirport: boolean
  hasFlights: boolean
  departingFeederEstimatedPrice?: number
  returningFeederEstimatedPrice?: number
}): boolean {
  if (!isConfiguredFeederAirport) return false
  if (!hasFlights) return true
  return (departingFeederEstimatedPrice ?? 0) > 0 || (returningFeederEstimatedPrice ?? 0) > 0
}

export function extractBaggageInfo(fareFamily?: App.FareFamily): {
  carryOnBaggage: App.FareFamilyFeature | undefined
  checkedBaggage: App.FareFamilyFeature | undefined
} {
  const carryOnBaggage = fareFamily?.fareFeatures.find(feature => (
    (
      // The `type` values coming from the API don't match what's defined in `App.FareFamilyFeatureType` :(
      feature.type === 'BAGGAGE_CARRY_ON' as App.FareFamilyFeatureType ||
      feature.type === 'carry_on_baggage'
    ) && feature.status === 'INCLUDED'
  ))

  const checkedBaggage = fareFamily?.fareFeatures.find(feature => (
    (
      feature.type === 'BAGGAGE_CHECKED' as App.FareFamilyFeatureType ||
      feature.type === 'checked_baggage'
    ) && feature.status === 'INCLUDED'
  ))

  return {
    carryOnBaggage,
    checkedBaggage,
  }
}
